import { api } from "./api";

export type QuickbooksConnectionStatus = {
  is_connected: boolean;
  workspace_id?: number;
  realm_id?: string;
  error_message?: string;
  token_status?: string; // only present when is_connected is false and no workspace exists
};

type QuickbooksOAuthResponse = {
  message: string;
  workspace_id: number;
  reconnected: boolean;
};

export const quickbooksAPI = api.injectEndpoints({
  endpoints: (build) => ({
    initiateOAuthFlow: build.mutation<{ url: string }, void>({
      query: () => ({
        url: "api/v1/initiate-oauth-flow/",
        method: "POST",
      }),
    }),
    completeOAuthFlow: build.mutation<
      QuickbooksOAuthResponse,
      { authorizationCode: string; realmId: string }
    >({
      query: (data) => ({
        url: "api/v1/complete-oauth-flow/",
        method: "POST",
        body: data,
      }),
    }),
    reconnectOAuthFlow: build.mutation<
      QuickbooksOAuthResponse,
      { authorizationCode: string; realmId: string }
    >({
      query: (data) => ({
        url: "api/v1/reconnect-oauth-flow/",
        method: "POST",
        body: data,
      }),
    }),
    disconnectQuickBooks: build.mutation<void, void>({
      query: () => ({
        url: "api/v1/disconnect-quickbooks/",
        method: "POST",
      }),
      invalidatesTags: ["QuickbooksWorkspace"],
    }),
    getConnectionStatus: build.query<QuickbooksConnectionStatus, void>({
      query: () => ({
        url: "api/v1/quickbooks-workspaces/connection_status/",
      }),
      providesTags: ["QuickbooksWorkspace"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          // error will be handled by the component
          console.error("QuickBooks error details:", error);
        }
      },
    }),
  }),
});

export const {
  useInitiateOAuthFlowMutation,
  useCompleteOAuthFlowMutation,
  useReconnectOAuthFlowMutation,
  useDisconnectQuickBooksMutation,
  useGetConnectionStatusQuery,
} = quickbooksAPI;
